import { useQuery } from '@tanstack/react-query';
import { fetchCarePlanInitialScores } from '../services/care_plan';

const useCarePlanInitialScore = (patientId, carePlanType) => {
    return useQuery({
        queryKey: ['carePlanInitialScores', patientId, carePlanType],
        queryFn: () => fetchCarePlanInitialScores(patientId, carePlanType),
        enabled: !!patientId && !!carePlanType,
        staleTime: 0, // always refetch so newly signed careplans update the baseline
    });
};

export default useCarePlanInitialScore;
